const localization = {
    cannot_delete_default_language: '{{languageTag}} ist die Standard-Sprache und kann nicht gelöscht werden.',
    invalid_translation_structure: 'Ungültige Übersetzungsstruktur. Bitte überprüfe deine Eingabe.',
};
export default localization;
